// pages/Dashboard.jsx
import WishlistPage from "../../components/home/WishlistPage";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <WishlistPage />
    </HomeLayout>
  );
}
